import React, { useRef } from 'react';
var VeltCommentSidebarV2FilterDropdownContentListItemCount = function (props) {
    var count = props.count, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-sidebar-filter-dropdown-content-list-item-count-v2", { ref: ref, count: count !== undefined && count !== null ? String(count) : undefined, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentSidebarV2FilterDropdownContentListItemCount;
